import React, { Component } from 'react';
import { SmartLink } from './SmartLink';
import { ArcaSecurity } from '../../../code/ArcaSecurity';

export class UserLinksPanel extends Component {

    constructor(props) {
        super(props);
        this.state = { logo: null };
    }

    render() {
        var userType = ArcaSecurity.UserType;
        var userId = ArcaSecurity.UserId;

        return (
            <span>

                <h4 className='centerText'>
                    {ArcaSecurity.IsLoggedIn
                        ? 'You are logged in!'
                        : 'Please log in!'}
                </h4>

                {(userType === 'Owner' || userType === 'Walker')
                    ? <SmartLink text='Your details' link={'/personview?id=' + userId} /> : null}

            </span>
        );
    }
}